/* eslint-disable no-undef */
import axios from 'axios'
import store from '@/store'

const api = {
  init() {
    window.FirebasePlugin.onMessageReceived((message) => {
      console.log('Got device new message')
      console.log(message)
      if (message && message.tap) {
        if (message.url) {
          window.location = message.url
        }
      }
      if (window.cordova !== undefined && device.platform === 'iOS') {
        window.FirebasePlugin.setBadgeNumber(0)
      }
    }, (error) => {
      console.error(error)
    })

    window.FirebasePlugin.onTokenRefresh((token) => {
      console.log('Got device token: ', token)
      this.subscribe(token)
    }, (error) => {
      console.error(error)
    })

    window.FirebasePlugin.hasPermission((hasPermission) => {
      if (!hasPermission) {
        window.FirebasePlugin.grantPermission()
      }
    })
  },

  getTokenAndSubscribe() {
    window.FirebasePlugin.hasPermission((hasPermission) => {
      if (hasPermission) {
        window.FirebasePlugin.getToken((token) => {
          console.log('Got device token: ', token)
          this.subscribe(token)
        }, (error) => {
          console.error(error)
        })
      } else {
        window.FirebasePlugin.grantPermission()
      }
    })
  },

  subscribe(token) {
    if (store.getters['auth/authenticated']) {
      axios.post(
        `${process.env.APP_BASE_URL}/messages/add-device`,
        {
          user_id: store.getters['auth/profile'].userName,
          platform: device.platform,
          device_id: device.uuid,
          token: token,
        }).then(() => {
        console.log('Subscribed for push notifications')
      }).catch((error) => {
        console.log('Failed to subscribe: ', error)
      })
    }
  },

  unsubscribe(userName) {
    axios.post(
      `${process.env.APP_BASE_URL}/messages/remove-device`,
      {
        user_id: userName,
        platform: device.platform,
        device_id: device.uuid,
      }).then(() => {
      console.log('Unsubscribed for push notifications')
    }).catch((error) => {
      console.log('Failed to unsubscribed: ', error)
    })
  },
}

export default api



// WEBPACK FOOTER //
// ./src/services/device-push.js